import React, { useRef } from 'react';
import PropTypes from 'prop-types';
import queryString from 'query-string';
import Pagination from '@/components/pagination/Pagination';
import useScrollToTop from '@/hooks/useScrollToTop';
import Results from './Results';
import useFilterCount from '@/hooks/useFilterCount';
import useQuery from './useQuery';
import DistanceFilter from '@/pages/people-partners/DistanceFilter';
import FilterButton from '@/pages/people-partners/FilterButton';
import PaginationInformation from '@/components/pagination/PaginationInformation';
import { attributeKeys } from './queryUtils';
import useDialogLauncher from '@/dialogs-routable/_hooks/useDialogLauncher';
import useDialogConfig from '@/dialogs-routable/_hooks/useDialogConfig';
import { DialogManager } from '@/dialogs_new/DialogManager';
import _ from 'lodash';

Layout.propTypes = {
  offer: PropTypes.shape({}),
  router: PropTypes.shape({
    location: PropTypes.shape({
      search: PropTypes.string
    }).isRequired
  }).isRequired
};

export default function Layout(props) {
  const { offer, router } = props;

  const { location } = router;

  const search = queryString.parse(location.search);
  const filterCount = useFilterCount(search, _.filter(attributeKeys, key => [
    'locationCondition'
  ].indexOf(key) < 0));

  const node = useRef();
  const scrollToTop = useScrollToTop();

  const pageSize = 16;

  const result = useQuery({
    search,
    pageSize
  });

  const launch = useDialogLauncher();
  const config = useDialogConfig();

  function showFilters() {
    launch(DialogManager.FiltersEducator.Config(config?.id));
  }

  return (
    <>
      <div ref={node} className="flex flex-col sm:flex-row flex-wrap gap-4 justify-between">
        <div className="flex flex-col sm:flex-row gap-4">
          <DistanceFilter />
        </div>
        <div className="flex flex-col sm:flex-row gap-4">
          {/*<SortBy />*/}
          <FilterButton
            count={filterCount}
            onClick={showFilters}
          />
        </div>
      </div>
      <Results
        offer={offer}
        result={result}
      />
      <div className="flex items-center justify-between">
        <PaginationInformation
          pageSize={pageSize}
          totalCount={result.meta?.totalCount}
        />
        <Pagination
          pageSize={pageSize}
          totalCount={result.meta?.totalCount}
          onNavigate={() => scrollToTop(node)}
        />
      </div>
    </>
  );
}
